import _regeneratorRuntime from "/home/jenkins/workspace/buch-editor-frontend_master-HFHSIVOQ6IJI5ZBPHCHU7A6EKU7FAGJSAKF6XQUXPUJGATAUMFRQ/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var _marked4 =
/*#__PURE__*/
_regeneratorRuntime.mark(handleGeneralFormSubmit),
    _marked5 =
/*#__PURE__*/
_regeneratorRuntime.mark(_callee);

import { takeEvery, put, select, getFormValues, getFormInitialValues, reset, startSubmit, stopSubmit } from '../dependencies';
import types from './actionTypes';

function handleGeneralFormSubmit(action) {
  var _marked, _marked2, _marked3, submitActionCreator, form, data, initialData, start, stop, res;

  return _regeneratorRuntime.wrap(function handleGeneralFormSubmit$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          res = function res() {
            return _regeneratorRuntime.wrap(function res$(_context3) {
              while (1) {
                switch (_context3.prev = _context3.next) {
                  case 0:
                    _context3.next = 2;
                    return put(reset(form));

                  case 2:
                  case 'end':
                    return _context3.stop();
                }
              }
            }, _marked3, this);
          };

          stop = function stop(errors) {
            return _regeneratorRuntime.wrap(function stop$(_context2) {
              while (1) {
                switch (_context2.prev = _context2.next) {
                  case 0:
                    _context2.next = 2;
                    return put(stopSubmit(form, errors));

                  case 2:
                  case 'end':
                    return _context2.stop();
                }
              }
            }, _marked2, this);
          };

          start = function start() {
            return _regeneratorRuntime.wrap(function start$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    _context.next = 2;
                    return put(startSubmit(form));

                  case 2:
                  case 'end':
                    return _context.stop();
                }
              }
            }, _marked, this);
          };

          _marked =
          /*#__PURE__*/
          _regeneratorRuntime.mark(start), _marked2 =
          /*#__PURE__*/
          _regeneratorRuntime.mark(stop), _marked3 =
          /*#__PURE__*/
          _regeneratorRuntime.mark(res);
          submitActionCreator = action.submitActionCreator, form = action.form;
          _context4.next = 7;
          return select(getFormValues(form));

        case 7:
          data = _context4.sent;
          _context4.next = 10;
          return select(getFormInitialValues(form));

        case 10:
          initialData = _context4.sent;

          if (!submitActionCreator) {
            _context4.next = 14;
            break;
          }

          _context4.next = 14;
          return put(_extends({}, submitActionCreator(), {
            data: data,
            form: form,
            initialData: initialData,
            reset: res,
            startSubmit: start,
            stopSubmit: stop
          }));

        case 14:
        case 'end':
          return _context4.stop();
      }
    }
  }, _marked4, this);
}

export default function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return takeEvery(types.FORM_SUBMIT, handleGeneralFormSubmit);

        case 2:
        case 'end':
          return _context5.stop();
      }
    }
  }, _marked5, this);
}